import { call, put, takeEvery } from 'redux-saga/effects';
import { searchByHotColdList } from '../../requests/search_by_hot_cold_requests';
import { searchHCRequestSuccess, searchHCRequestFailure } from '../actions/search_hc.actions';
import { SEARCH_HC_REQUEST } from '../constants/bike_model.constants';
import { countBikeModels } from '../../requests/get_all_bikes_request';
import { countBikeModelsRequestFailure, countBikeModelsRequestSuccess } from '../actions/count_bike_models.actions';

function* searchByHCRequest({ where }) {
    const { result, options, error } = yield call(searchByHotColdList, where);
    if (result) {
        const { result, options: { amount }, error } = yield call(countBikeModels, where, 'variants');
        result
            ? yield put(countBikeModelsRequestSuccess(amount))
            : yield put(countBikeModelsRequestFailure(error));
        const models = options.map(option => option.ref_bike_model);
        yield put(searchHCRequestSuccess(models));
    } else {
        yield put(searchHCRequestFailure(error));
    }
}

export default function* searchByHCSaga() {
    yield takeEvery(SEARCH_HC_REQUEST, searchByHCRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/search_by_hot_cold.saga.js